import { AxiosResponse } from 'axios';
import { ICreditLimitRequestsResponse } from '../types/api/creditLimitRequestsApi';
import { getAuthToken } from '../utils/commonHelper';
import { ITableRequestData } from '../types/common';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/credit-limit-requests`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};

export const 
getCreditLimitRequestsDataService = async ({ limit, page }: ITableRequestData): Promise<AxiosResponse<ICreditLimitRequestsResponse>> => {
    try {
        let url = `${API_URL}/table`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}`;

        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getCreditLimitRequestDetailService = async ({ id }: { id: string }): Promise<AxiosResponse<ICreditLimitRequestsResponse>> => {
    try {
         // // // console.log("service", { id });
        const response = await axiosInstance.get(`${API_URL}/${id}`, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const updateCreditLimitStatusQuery = async (id: string, status: string): Promise<AxiosResponse<ICreditLimitRequestsResponse>> => {
    try {
        const response = await axiosInstance.put(`${API_URL}/update-status/${id}`, {
            status
        }, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};  
